/**
 * Utility functions for managing requesterId in localStorage
 */

const REQUESTER_ID_KEY = 'LOGISTICS_REQUESTER_ID';

/**
 * Generate a unique requesterId if not already present
 */
export const initializeRequesterId = (): string => {
  let requesterId = localStorage.getItem(REQUESTER_ID_KEY);
  
  if (!requesterId) {
    // Generate a unique ID using timestamp and random string
    requesterId = '86034d46-e1a1-4280-a2b1-9d5dfadd7a7d';
    localStorage.setItem(REQUESTER_ID_KEY, requesterId);
    console.log('[Storage] New requesterId created:', requesterId);
  }
  
  return requesterId;
};

/**
 * Get the current requesterId from localStorage
 */
export const getRequesterId = (): string => {
  const requesterId = localStorage.getItem(REQUESTER_ID_KEY);
  
  if (!requesterId) {
    return initializeRequesterId();
  }
  
  return requesterId;
};

/**
 * Set a custom requesterId
 */
export const setRequesterId = (id: string): void => {
  localStorage.setItem(REQUESTER_ID_KEY, id);
  console.log('[Storage] requesterId updated:', id);
};

/**
 * Clear the requesterId from localStorage
 */
export const clearRequesterId = (): void => {
  localStorage.removeItem(REQUESTER_ID_KEY);
  console.log('[Storage] requesterId cleared');
};
